module.exports = __webpack_public_path__ + "static/media/6.1ed61b5d.jpg";